import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { FoldableLetter } from '@tecuity/granite-ui/FoldableLetter'
// import { format } from 'date-fns'

const LetterTemplate = () => {
  const corrInfo = useSelector((state) => state.correspondence2, shallowEqual)
  const {
    CustomCorrespondenceTypeId,
    CustomCorrespondenceTypeName,
    RecordName,
    SourceType,
    CustomCorrespondenceNumber,
    LastModifiedByName,
    FilingDate,
    CustomCorrespondenceReasons = [],
    folded = false,
  } = corrInfo

  const barcodeSrc = ''

  const headerSrc =    
    require('../../common/img/seals/' +
      process.env.STATE_ABBR +
      (process.env.CORRESPONDENCE_HEADER ? `/${process.env.CORRESPONDENCE_HEADER}` : '/seal.svg'))

  const conclusionHeader = `What's Next?`

  const conclusion =
    process.env.CORRESPONDENCE_CONCLUSION ||
    'You may correct your submission as detailed above and resubmit for review by logging into your online account.'

  const EntityOrOwner = process.env.REJECTION_CORRECTION_ENTITY_lABEL || 'Entity'

  return (
    // <div style={{ zIndex: -2300 }}>
    <FoldableLetter
      folded={folded}
      toBlock={<LocalToBlock />}
      fromBlock={
        <div>
          {process.env.CORRESPONDENCE_ADDRESS.map((line, i) => (
            <div style={{ padding: 3 }} key={i}>
              {line}
            </div>
          ))}
        </div>
      }
    >
      <div className="floating-card-stripes">
        <div className="letter-wrapper">
          <div className="letter-content">
            {barcodeSrc && (
              <div className="barcode-row">
                <img className="barcode" src={barcodeSrc} alt=""></img>
              </div>
            )}
            <img className="header-row" src={headerSrc} alt=""></img>
            <div className="separator"></div>
            <div className="notice-title">Notice of {CustomCorrespondenceTypeName}</div>
            <div className="letter-info">
              {FilingDate.split(' ')[0]}
              <br></br>
              <br></br>
	  	{RecordName && RecordName !== '' && (
                <span>
                  <b>{EntityOrOwner} Name: </b> {RecordName}
                </span>
              )}

              <span>
                <b>Document Type: </b> {SourceType}
              </span>
              <span>
                <b>{CustomCorrespondenceTypeName} Number: </b> {CustomCorrespondenceNumber}
              </span>
              <span>
                <b>Document Reviewed by: </b> {LastModifiedByName}
              </span>
            </div>
            <div className="letter-body">
              Thank you for your recent submission. The above referenced document has been reviewed
              and does not meet legal compliance.
              <div className="subheading">
                {CustomCorrespondenceTypeId === 1 ? 'Rejection Reasons' : 'Corrections Needed'}
              </div>
              {CustomCorrespondenceTypeId === 1
                ? 'The following reasons are why the submission cannot be processed:'
                : 'The following corrections are needed before the submission can be processed:'}
              {CustomCorrespondenceReasons.length > 0 ? (
                CustomCorrespondenceReasons.map((reason, index) => (
                  <div className="reason-wrapper" key={index}>
                    <div className="reason">{reason.parsedReason || reason.LongReason}</div>
                  </div>
                ))
              ) : (
                <div className="dashed-border-box">Select reasons to display them here...</div>
              )}
              <div className="subheading">{conclusionHeader}</div>
              <div>{conclusion}</div>
            </div>
          </div>
        </div>
      </div>
    </FoldableLetter>
    // </div>
  )
}

export default LetterTemplate

const LocalToBlock = () => {
  const {
    CustomCorrespondenceRecipient: letterFront = {},
    isEmail = false,
    isSnailMail = false,
  } = useSelector((state) => state.correspondence2, shallowEqual)
  return (
    <div className="toBlock">
      <React.Fragment>
        {isEmail && !isSnailMail && (
          <div className="toName" id="email">
            {letterFront.Email}
          </div>
        )}
        {isSnailMail && (
          <div>
            <div className="toName" id="name">
              {letterFront.Name && letterFront.Name}
            </div>
            <span id="to">{letterFront.To ? `C/O ${letterFront.To}` : ``}</span>
            <div>
              <span id="address">{letterFront.Address1}</span>&nbsp;
              <span id="ste">{letterFront.Address2}</span>&nbsp;
              <span id="att">{letterFront.Address3}</span>
            </div>
            <span id="city">{letterFront.City}</span>&nbsp;
            <span id="state">{letterFront.State}</span>
            &nbsp;
            <span id="zip">{letterFront.PostalCode}</span>
          </div>
        )}
      </React.Fragment>
    </div>
  )
}
